import { __rest } from "tslib";
import React from 'react';
import Position from './Position';
/** @type {any} */
const PinTR = React.forwardRef((_a, ref) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (React.createElement(Position, Object.assign({ position: "absolute", ref: ref, right: 0, top: 0 }, props), children));
});
export default PinTR;
